import {GLOBALEVENTMANAGER}		from "../../applicationManager";
import {getDataNodeByUUID}		from "../../dataManager";

import "jquery.fancytree/dist/modules/jquery.fancytree.dnd5";


// for details on Fancytree-dnd5 extension, see https://github.com/mar10/fancytree/wiki/ExtDnd5


export const fancytreeDnd5 = {
	// Available options with their defaults:
	autoExpandMS: 250,							// Expand nodes after n milliseconds of hovering.
	dropMarkerOffsetX: -24,					// absolute position offset for .fancytree-drop-marker, relatively to ..fancytree-title (icon/img near a node accepting drop)
	dropMarkerInsertOffsetX: -16,		// additional offset for drop-marker with hitMode = "before"/"after"
	dropMarkerParent: "body",				// Root Container used for drop marker (could be a shadow root)
	effectAllowed: "all",						// Restrict the possible cursor shapes and modifier operations, (can also be set in the dragStart event)
	dropEffectDefault: "move",			// Default dropEffect ('copy', 'link', or 'move'), when no modifier is pressed (override in dragDrag, dragOver).
	multiSource: false,							// true: Drag multiple (i.e. selected) nodes, also a callback() is allowed to return a node list
	preventForeignNodes: false,			// Prevent dropping nodes from another Fancytree
	preventLazyParents: true,				// Prevent dropping items on unloaded lazy Fancytree nodes
	preventNonNodes: false,					// Prevent dropping items other than Fancytree nodes
	preventRecursion: true,					// Prevent dropping nodes on own descendants when in move-mode
	preventSameParent: false,				// Prevent dropping nodes under same direct parent
	preventVoidMoves: true,					// Prevent moving nodes 'before self', etc.
	scroll: true,										// Enable auto-scrolling while dragging
	scrollSensitivity: 20,					// Active top/bottom margin in pixel
	scrollSpeed: 5,									// Pixel per event
	setTextTypeJson: false,					// Allow dragging of nodes to different IE windows
	sourceCopyHook: null,						// Optional callback passed to `toDict` on dragStart @since 2.38
	// Events (drag support)
	//! dragStart: null,								// Callback(sourceNode, data), return true, to enable dragging
	// dragDrag: null,								// Callback(sourceNode, data)
	// dragEnd: null,								// Callback(sourceNode, data)
	// Events (drop support)
	//! dragEnter: null,								// Callback(targetNode, data), return true, to enable dropping
	dragOver: null,								// Callback(targetNode, data)
	dragExpand: null,							// Callback(targetNode, data)
	//! dragDrop: null,								// Callback(targetNode, data)
	// dragLeave: null, 							// Callback(targetNode, data)

	dragStart: (node) => node.data.draggable,		// returns true/false to prevent/allow dragging of certain nodes

	dragEnter: (node, data) => {
		const dragTargetNodeType = node.type;
		const draggedNodeType = data.otherNode.type;

		switch (true) {
			case (dragTargetNodeType === "ProjectNode" && draggedNodeType !== "AssemblyNode"):																							// can't drag otter than AssemblyNodes on ProjectNode
				return false;
			case (dragTargetNodeType === "AssemblyNode" && (draggedNodeType !== "DeviceNode" && draggedNodeType !== "UnitNode")):						// can't drag otter than DeviceNodes & UnitNodes on AssemblyNode
				return false;
			case (dragTargetNodeType === "InfrastructureNode" && (draggedNodeType !== "DeviceNode" && draggedNodeType !== "UnitNode")):			// can't drag otter than DeviceNodes & UnitNodes on InfrastructureNode
				return false;
			case (dragTargetNodeType === "DeviceNode"):			// can't drag onto DeviceNodes
				return false;
			case (dragTargetNodeType === "UnitNode"):				// can't drag onto UnitNodes
				return false;
			default:
				return true;
		}
	},

	dragDrop: (node, data) => {
		const dragTargetNode = node;
		const draggedNode = data.otherNode;

		draggedNode.moveTo(dragTargetNode, data.hitMode);
		GLOBALEVENTMANAGER.dispatch("eOL_RelocateTreeNode", getDataNodeByUUID(draggedNode.key), getDataNodeByUUID(dragTargetNode.key));
	},
};
